import {Component, Input} from '@angular/core';
import {
  PrecipitationSvgComponent
} from "src/app/presentation/common/icons/precipitation-svg/precipitation-svg.component";
import {FixedSamplePoint} from 'src/app/infrastructure/moovement-api/models/asset';


@Component({
  selector: 'app-precipitation-point-marker',
  imports: [
    PrecipitationSvgComponent
  ],
  templateUrl: './precipitation-point-marker.component.html',
  styleUrl: './precipitation-point-marker.component.css'
})
export class PrecipitationPointMarkerComponent {

  @Input() name: string = '';
  @Input() iconName: string = '';
  @Input() precipitationPoint?: FixedSamplePoint;
}
